// extracted by mini-css-extract-plugin
export default {"qrCode":"App_qrCode__rAD+k","app":"App_app__11rd-"};